import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

try {
  window.$ = window.jQuery = require("jquery");
  require("bootstrap");
} catch (e) {}

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.MIX_SENTRY_JAVASCRIPT_DSN,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}
